import { render, staticRenderFns } from "./AlphabeticalNavigation.vue?vue&type=template&id=9dd89b9c&scoped=true&"
import script from "./AlphabeticalNavigation.vue?vue&type=script&lang=js&"
export * from "./AlphabeticalNavigation.vue?vue&type=script&lang=js&"
import style0 from "./AlphabeticalNavigation.vue?vue&type=style&index=0&id=9dd89b9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dd89b9c",
  null
  
)

export default component.exports